export function sanitizeSlug(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9-]/g, '-');
}

/** Gera slug legível a partir do nome (remove acentos, normaliza hífens). */
export function slugFromName(name: string): string {
  const normalized = name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  return sanitizeSlug(normalized)
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

/** Retorna slug único; se `baseSlug` já existir, tenta `-2`, `-3`, … */
export function suggestUniqueSlug(baseSlug: string, existingSlugs: readonly string[]): string {
  const base = baseSlug.replace(/^-|-$/g, '');
  if (!base) return '';

  const taken = new Set(existingSlugs.map((s) => s.toLowerCase()));
  if (!taken.has(base)) return base;

  for (let i = 2; i < 1000; i++) {
    const candidate = `${base}-${i}`;
    if (!taken.has(candidate)) return candidate;
  }

  return `${base}-${Date.now()}`;
}
